export default {
  I: {
    value: 1
  },
  V: {
    value: 5
  },
  X: {
    value: 10
  },
  L: {
    value: 50
  },
  C: {
    value: 100
  },
  D: {
    value: 500
  },
  M: {
    value: 1000
  }
  // N: {
  //   value: 0
  // }
};
